import styled from 'styled-components'

export const ClientListContainer = styled.div``

export const ClientListSearchContainer = styled.div`
  /* margin-bottom: 20px;
  width: 25%; */
  display: flex;
  align-items: center;
  justify-content: space-between;
`
